import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type ContainerVariant = 'default' | 'dark' | 'white';
export type ContainerPadding = 'none' | 'sm' | 'md' | 'lg';

@Component({
  selector: 'app-content-container',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './content-container.component.html',
  styleUrls: ['./content-container.component.css']
})
export class ContentContainerComponent {
  @Input() variant: ContainerVariant = 'default';
  @Input() padding: ContainerPadding = 'md';
  @Input() maxHeight: string | null = null;

  get containerClass(): string {
    const classes = [
      `variant-${this.variant}`,
      `padding-${this.padding}`
    ];
    return classes.join(' ');
  }
}
